export interface CostComponentSplitItem {
  description: string;
  costComponent: string;
  splitType: CostComponentSplitType;
  totalValue: number;
  fixedValue: number;
  variableValue: number;
  currency: string;
}

export enum CostComponentSplitType {
  MAIN,
  AUX,
  TOTAL,
}
